import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiaryItem, GetUserInfoResponse } from '@schema/APITypes';

@Component({
  selector: 'lgv-diary-more-table-item',
  template: `
    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="editClicked.emit()">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span translate>shared_component_generictable_edit</span>
      </button>
      @if (!diary.readByOrganization) {
        <button mat-menu-item (click)="readClicked.emit()">
          <mat-icon class="material-icons-outlined">drafts</mat-icon>
          <span translate>shared_component_generictable_read</span>
        </button>
      }
      <button mat-menu-item (click)="deleteClicked.emit()">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span translate>shared_component_generictable_delete</span>
      </button>
    </mat-menu>
  `,
  standalone: false,
})
export class DiaryMoreTableItemComponent {
  @Input() diary: DiaryItem;
  @Input() currentUser: GetUserInfoResponse;
  @Output() editClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<void>();
  @Output() readClicked = new EventEmitter<void>();
}
